import store from "../app/store";
import { dmApi } from "../app/dmApi";
import { disconnectSocket } from "../socket/socketClient";
import { clearRedirectPath } from "../app/globalSlice";

let logoutInProgress = false;

/** All roles always land on the shared frontend login page after logout. */
export const SHARED_LOGIN_PATH = "/login";

const PUBLIC_AUTH_PATHS = [
  "/login",
  "/audiologist/login",
  "/forget-password",
  "/reset-password",
  "/create-password",
];

export function isLogoutInProgress() {
  return logoutInProgress;
}

export function shouldSkipAuthedQuery() {
  return logoutInProgress || !localStorage.getItem("authToken");
}

export function isPublicAuthRoute(pathname = window.location.pathname) {
  return PUBLIC_AUTH_PATHS.some(
    (path) => pathname === path || pathname.endsWith(path)
  );
}

export function getFrontendLoginPath() {
  return SHARED_LOGIN_PATH;
}

function toAbsoluteLoginUrl(pathOrUrl) {
  if (pathOrUrl && /^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl;
  }
  const path = SHARED_LOGIN_PATH;
  return `${window.location.origin}${path}`;
}

export function getLoginUrl() {
  const baseUrl = (import.meta.env.VITE_BASE_URL || "").replace(/\/$/, "");
  return `${baseUrl}/auth/login`;
}

export function getLogoutUrl(returnPath) {
  const baseUrl = (import.meta.env.VITE_BASE_URL || "").replace(/\/$/, "");
  const returnTo = toAbsoluteLoginUrl(returnPath);
  return `${baseUrl}/auth/logout?returnTo=${encodeURIComponent(returnTo)}`;
}

export function clearAuthSession() {
  disconnectSocket();
  localStorage.removeItem("authToken");
  sessionStorage.clear();
  store.dispatch(dmApi.util.resetApiState());
  store.dispatch(clearRedirectPath());
}

/** Soft redirect to shared login (401 / expired session). */
export function redirectToLogin() {
  if (logoutInProgress || isPublicAuthRoute()) {
    return;
  }
  logoutInProgress = true;
  clearAuthSession();
  window.location.replace(SHARED_LOGIN_PATH);
}

/**
 * Full sign-out: clear local session and Auth0 SSO.
 * Always returns the user to /login on the current origin
 * (e.g. https://dev.captify.glass/login).
 */
export function logout(returnPath = SHARED_LOGIN_PATH) {
  if (logoutInProgress) {
    return;
  }
  logoutInProgress = true;

  const logoutUrl = getLogoutUrl(returnPath || SHARED_LOGIN_PATH);
  clearAuthSession();
  window.location.replace(logoutUrl);
}

/** Call from API 401 handlers — avoid logout loops after session is already cleared. */
export function handleUnauthorized() {
  if (logoutInProgress || isPublicAuthRoute()) {
    return;
  }

  const hasToken = !!localStorage.getItem("authToken");
  if (!hasToken) {
    return;
  }

  redirectToLogin();
}
